module.exports = __webpack_public_path__ + "img/i-roles-4.6b41da14.png";